import { render, staticRenderFns } from "./AbkEventsListBox.vue?vue&type=template&id=28b6b904&scoped=true&"
import script from "./AbkEventsListBox.vue?vue&type=script&lang=js&"
export * from "./AbkEventsListBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventsListBox.vue?vue&type=style&index=0&id=28b6b904&scoped=true&lang=scss&"
import style1 from "./AbkEventsListBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6b904",
  null
  
)

export default component.exports